import { useState, useEffect } from 'react';
import { getAnnouncements } from '../../../../consumer_web/app/modules/containers/AnnouncementContainer/AnnouncementAPI';
import { Logger } from '../../utils';
import announcementTypes from '../Announcement/announcementTypes';

/**
 * Custom hook to fetch GDA notification data.
 * @param {Object} params - Parameters for the API call.
 * @returns {Object} { data, loading, error }
 */
const useGdaNotificationData = ({
  deviceId, locationCode, flowContext, fetchData,
}) => {
  const { POPUP } = announcementTypes;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await getAnnouncements({ deviceId, locationCode, flowContext });
        const normalizedResponse = response == null ? [] : response;
        const tiles = normalizedResponse.filter((item) => item.display?.web?.type === POPUP);
        const announcement = tiles?.[0];
        if (announcement) {
          const { id, display = {}, action = {} } = announcement;
          const {
            title, image, content, action_text: ctaLabel,
          } = display;
          const contentList = content?.split('\r\n');
          setData({
            id,
            header: title,
            imageUrl: image,
            contentList,
            ctaLabel,
            ctaLink: action.data?.url,
          });
        }
        setError(null);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        Logger.error('[GDA Notification Data Hook] error fetching announcements', err);
      }
    };
    if (fetchData && deviceId && locationCode) {
      setLoading(true);
      fetchAnnouncements();
    }
  }, [deviceId, locationCode, flowContext, fetchData]);

  return { data, loading, error };
};

export default useGdaNotificationData;
